<template>
  <div class="layout-right">
		<div class="module">
			<title-bar title="设备数据"></title-bar>
			<div class="module-content">
				<div class="module-1">
					<div class="module-1-item">
						<div class="module-1-item-title">总设备数</div>
						<div class="module-1-item-text">251,414</div>
						<img class="module-1-item-bottom" src="@/assets/data-center/bottom.gif" />
					</div>
					<div class="module-1-item">
						<div class="module-1-item-title">总端口数</div>
						<div class="module-1-item-text">551,414</div>
						<img class="module-1-item-bottom" src="@/assets/data-center/bottom.gif" />
					</div>
				</div>
				<div class="module-2">
					<div class="module-2-item">
						<div class="item-circle" style="background: #00E074"></div>
						<div class="item-text">在线 52,226</div>
					</div>
					<div class="module-2-item">
						<div class="item-circle" style="background: #FE8A00"></div>
						<div class="item-text">离线 52,226</div>
					</div>
					<div class="module-2-item">
						<div class="item-circle" style="background: #EA04FF"></div>
						<div class="item-text">忙碌 52,226</div>
					</div>
					<div class="module-2-item">
						<div class="item-circle" style="background: #00A6FF"></div>
						<div class="item-text">空闲 52,226</div>
					</div>
				</div>
				<div class="module-3">
					<div class="module-3-item">
						<div class="item-value">72%</div>
						<div class="item-name">日均使用率</div>
					</div>
					<div class="module-3-item">
						<div class="item-value">58%</div>
						<div class="item-name">即时使用率</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TitleBar from './title-bar.vue'
export default {
	components: { TitleBar },
}
</script>

<style lang="scss" scoped>
.layout-right {
	width: 400px;
	.module {
		margin-bottom: 40px;
		.module-content {
			padding: 24px 0;
			margin-top: 15px;
			width: 100%;
			background: #141518;
			.module-1 {
				padding: 0 36px;
				display: flex;
				justify-content: center;
				gap: 40px;
				.module-1-item {
					display: flex;
					flex-direction: column;
					align-items: center;
					.module-1-item-title {
						width: 120px;
						height: 40px;
						background: url('../../../../../assets/data-center/title-bg.png') no-repeat;
						background-size: 100%;
						color: #fff;
						font-size: 16px;
						font-weight: bold;
						text-align: center;
						line-height: 40px;
					}
					.module-1-item-text {
						margin-top: 16px;
						font-size: 32px;
						font-weight: bold;
						color: #009DFF;
					}
					.module-1-item-bottom {
						width: 145px;
						margin-top: -70px;
					}
				}
			}
			.module-2 {
				padding: 24px 0 8px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-wrap: wrap;
				.module-2-item {
					width: 50%;
					display: flex;
					justify-content: center;
					align-items: center;
					margin-bottom: 16px;
					.item-circle {
						width: 10px;
						height: 10px;
						border-radius: 50%;
						background: #00E074;
						margin-right: 6px;
						border: 1px solid #FFFFFF;
					}
					.item-text {
						color: #fff;
						font-size: 16px;
						font-weight: bold;
					}
				}
			}
			.module-3 {
				padding: 0 24px;
				.module-3-item {
					margin-bottom: 16px;
					width: 352px;
					height: 120px;
					background: url('../../../../../assets/data-center/usage-rate-bg.png') no-repeat;
					background-size: 100%;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					.item-value {
						font-size: 32px;
						font-weight: bold;
						color: #009DFF;
					}
					.item-name {
						margin-top: 6px;
						font-size: 16px;
						font-weight: bold;
						color: #fff;
					}
				}
			}
		}
	}
}

</style>
